 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		56: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		56: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "script/chunks/chunk." + ({"8":"campaign-page~category-page~cause~causes-landing-page~profile-page~search-page","14":"vendors~quick-view~tradera","17":"checkout-page~view-item-page","18":"tradera-shop~view-item-page","20":"basic","21":"bidding","22":"detailed-search","23":"image-search","24":"messages","25":"messaging-iframe","26":"tradera","27":"vendors~braintree-web-drop-in","28":"vendors~messaging-iframe","29":"vendors~tradera","31":"quick-view","36":"brand-page","37":"campaign-page","39":"category-list-page","40":"category-page","41":"cause","42":"causes-info","43":"causes-landing-page","44":"checkout-confirmation-page","45":"checkout-page","46":"combined-shipping","48":"dis","50":"favourite-sellers","53":"inr","54":"landing-stadiumxtradera","55":"landing_gantxtradera","58":"print-page","59":"profile-page","61":"report-item-page","63":"search-page","65":"sellpy-summary-page","67":"shippingcalculator","71":"swish-app2app-callback-page","72":"tradera-shop","73":"upi","74":"valuation-page","75":"vendors~causes-info","78":"verify-page","79":"view-item-page"}[chunkId]||chunkId) + "." + {"3":"f42e5912a2","5":"d0815d1a1f","6":"15cf7e567a","7":"f38d5116e2","8":"4c76c73f35","11":"84e8f8c663","12":"3047106de9","14":"dc91c897e3","15":"a0468f405f","16":"be189e7b37","17":"c71750aeb0","18":"91d0b77494","20":"3149f784f3","21":"e8c276236c","22":"7e4fed797f","23":"2fede8499f","24":"a4013f604d","25":"673f149a49","26":"f8cd0270f6","27":"8c7698bf74","28":"7290281858","29":"769c6aa96a","30":"3a2575b7d6","31":"2e7da80c07","32":"27ad24b7b7","36":"71d9b60d10","37":"2536ef5d09","39":"9cafd08656","40":"8decdcc819","41":"0a517ea3e3","42":"c07d22776e","43":"c13c6063ba","44":"c6f55ea6e7","45":"bfbca28719","46":"181aefe906","48":"287714429a","50":"8528b1c7a0","53":"029e32fb92","54":"910be15c83","55":"8a487090f3","58":"62f571916f","59":"93d27cd2ef","61":"d26d7adfa6","63":"c96f54c05d","65":"4cc928ab02","67":"09044d6636","71":"cd57057f0e","72":"44acf85aa9","73":"fd9c5bcadd","74":"c74749c0d7","75":"3bf6d5fb6c","78":"11bfc3dcd4","79":"571989d2d6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"5":1,"8":1,"15":1,"17":1,"18":1,"22":1,"23":1,"25":1,"26":1,"29":1,"30":1,"31":1,"36":1,"37":1,"39":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"48":1,"50":1,"53":1,"54":1,"55":1,"58":1,"59":1,"61":1,"65":1,"67":1,"71":1,"72":1,"73":1,"74":1,"79":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "style/" + ({"8":"campaign-page~category-page~cause~causes-landing-page~profile-page~search-page","14":"vendors~quick-view~tradera","17":"checkout-page~view-item-page","18":"tradera-shop~view-item-page","20":"basic","21":"bidding","22":"detailed-search","23":"image-search","24":"messages","25":"messaging-iframe","26":"tradera","27":"vendors~braintree-web-drop-in","28":"vendors~messaging-iframe","29":"vendors~tradera","31":"quick-view","36":"brand-page","37":"campaign-page","39":"category-list-page","40":"category-page","41":"cause","42":"causes-info","43":"causes-landing-page","44":"checkout-confirmation-page","45":"checkout-page","46":"combined-shipping","48":"dis","50":"favourite-sellers","53":"inr","54":"landing-stadiumxtradera","55":"landing_gantxtradera","58":"print-page","59":"profile-page","61":"report-item-page","63":"search-page","65":"sellpy-summary-page","67":"shippingcalculator","71":"swish-app2app-callback-page","72":"tradera-shop","73":"upi","74":"valuation-page","75":"vendors~causes-info","78":"verify-page","79":"view-item-page"}[chunkId]||chunkId) + "." + {"3":"31d6cfe0d1","5":"4feff46597","6":"31d6cfe0d1","7":"31d6cfe0d1","8":"26fbbe60b3","11":"31d6cfe0d1","12":"31d6cfe0d1","14":"31d6cfe0d1","15":"d0c7b95f2d","16":"31d6cfe0d1","17":"b802116bde","18":"12cddd1395","20":"31d6cfe0d1","21":"31d6cfe0d1","22":"620d036928","23":"65d1a02572","24":"31d6cfe0d1","25":"3cae497698","26":"2f05f07dd8","27":"31d6cfe0d1","28":"31d6cfe0d1","29":"a0cfaf67ee","30":"6cf4368dc2","31":"4c54a6398f","32":"31d6cfe0d1","36":"fa64fc5460","37":"7f55555eed","39":"80590043df","40":"31d6cfe0d1","41":"f0f9fc3848","42":"445d3aa1df","43":"208d380766","44":"4de4eced98","45":"95df292634","46":"046e8b7b84","48":"d9c93c178d","50":"8fcc1dd461","53":"d9c93c178d","54":"4d48b7d7eb","55":"c691110343","58":"dd5220ddb8","59":"42cac38cd6","61":"7b917c2a6e","63":"31d6cfe0d1","65":"cfe76faa48","67":"8dc5db095f","71":"4de4eced98","72":"7a40aced25","73":"d9c93c178d","74":"ce1e1da122","75":"31d6cfe0d1","78":"31d6cfe0d1","79":"7df947bff7"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//static.tradera.net/touchweb/static/output/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([8,1,0,2,4,9,76,10]);
 	// run deferred modules when ready
 	return checkDeferredModules();
